import { createStore } from 'owa-satcheljs';
import type { LivePersonaEditorState } from './schema/LivePersonaEditorState';

export const getStore: () => LivePersonaEditorState = createStore<LivePersonaEditorState>(
    'NovaLivePersonaEditor',
    {
        isVisible: false,
        identifiers: {},
        hostAppContext: {},
        contactPrompt: '',
    }
);
